import React from 'react';
import './ConfirmDialog.css';

interface ConfirmDialogProps {
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
                                                                message,
                                                                onConfirm,
                                                                onCancel
                                                            }) => {
    return (
        <div className="confirm-overlay">
            <div className="confirm-dialog">
                <p>{message}</p>
                <div className="confirm-buttons">
                    <button className="btn-confirm" onClick={onConfirm}>
                        OK
                    </button>
                    <button className="btn-cancel" onClick={onCancel}>
                        Отмена
                    </button>
                </div>
            </div>
        </div>
    );
};